import { render, staticRenderFns } from "./reg-wallet-4.vue?vue&type=template&id=3d77df1e&scoped=true&lang=pug&"
import script from "./reg-wallet-4.vue?vue&type=script&lang=js&"
export * from "./reg-wallet-4.vue?vue&type=script&lang=js&"
import style0 from "./reg-wallet-4.vue?vue&type=style&index=0&id=3d77df1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77df1e",
  null
  
)

export default component.exports